/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agents_Name_Fatura_Analiz_AgentInputs */

const tr_agents_name_fatura_analiz_agent = /** @type {(inputs: Agents_Name_Fatura_Analiz_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiş & Fatura Asistanı`)
};

const en_agents_name_fatura_analiz_agent = /** @type {(inputs: Agents_Name_Fatura_Analiz_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receipt & Invoice Assistant`)
};

const de_agents_name_fatura_analiz_agent = /** @type {(inputs: Agents_Name_Fatura_Analiz_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beleg- & Rechnungsassistent`)
};

const ru_agents_name_fatura_analiz_agent = /** @type {(inputs: Agents_Name_Fatura_Analiz_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ассистент чеков и счетов`)
};

/**
* | output |
* | --- |
* | "Receipt & Invoice Assistant" |
*
* @param {Agents_Name_Fatura_Analiz_AgentInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const agents_name_fatura_analiz_agent = /** @type {((inputs?: Agents_Name_Fatura_Analiz_AgentInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Name_Fatura_Analiz_AgentInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agents_name_fatura_analiz_agent(inputs)
	if (locale === "de") return de_agents_name_fatura_analiz_agent(inputs)
	if (locale === "ru") return ru_agents_name_fatura_analiz_agent(inputs)
	return tr_agents_name_fatura_analiz_agent(inputs)
});